import { createRouter, createWebHistory } from 'vue-router'
import type { RouteRecordRaw } from 'vue-router'

// 页面组件
import HomeView from '@/views/HomeView.vue'
import LoginView from '@/views/LoginView.vue'
import RegisterView from '@/views/RegisterView.vue'
import BooksView from '@/views/BooksView.vue'
import ReadingView from '@/views/ReadingView.vue'
import BookshelfView from '@/views/BookshelfView.vue'
import BookDetailView from '@/views/BookDetailView.vue'
import ProfileView from '@/views/ProfileView.vue'
import AdminDashboard from '@/views/admin/AdminDashboard.vue'
import CreateView from '@/views/CreateView.vue'
const NotFoundView = () => Promise.resolve({ default: HomeView })
const MoonlitHomeView = () => import('@/views/moonlit/MoonlitHomeView.vue')
const MoonlitLibraryView = () => import('@/views/moonlit/MoonlitLibraryView.vue')
const MoonlitBookDetailView = () => import('@/views/moonlit/MoonlitBookDetailView.vue')
const MoonlitReaderView = () => import('@/views/moonlit/MoonlitReaderView.vue')
const MoonlitShelfView = () => import('@/views/moonlit/MoonlitShelfView.vue')
const MoonlitLoginView = () => import('@/views/moonlit/MoonlitLoginView.vue')
const MoonlitFeedbackView = () => import('@/views/moonlit/MoonlitFeedbackView.vue')
const MoonlitPolicyView = () => import('@/views/moonlit/MoonlitPolicyView.vue')

const routes: Array<RouteRecordRaw> = [
{
path: '/',
name: 'home',
component: HomeView,
meta: { title: '首页 - 菠萝蜜·沉浸式AI小说' }
},
{
path: '/moonlit',
name: 'moonlit-home',
component: MoonlitHomeView,
meta: { title: 'Moonlit - Bite-sized fantasy romance and gothic stories' }
},
{
path: '/moonlit/library',
name: 'moonlit-library',
component: MoonlitLibraryView,
meta: { title: 'Library - Moonlit' }
},
{
path: '/moonlit/books/:id',
name: 'moonlit-book-detail',
component: MoonlitBookDetailView,
meta: { title: 'Story - Moonlit' }
},
{
path: '/moonlit/read/:bookId/:chapterNumber',
name: 'moonlit-reader',
component: MoonlitReaderView,
meta: { title: 'Read - Moonlit' }
},
{
path: '/moonlit/login',
name: 'moonlit-login',
component: MoonlitLoginView,
meta: { title: 'Sign in - Moonlit', guestOnly: true, guestRedirect: '/moonlit/shelf' }
},
{
path: '/moonlit/shelf',
name: 'moonlit-shelf',
component: MoonlitShelfView,
meta: { title: 'Shelf - Moonlit', requiresAuth: true }
},
{
path: '/moonlit/feedback',
name: 'moonlit-feedback',
component: MoonlitFeedbackView,
meta: { title: 'Feedback - Moonlit' }
},
{
path: '/moonlit/:page(privacy|terms|ai-notice|safety)',
name: 'moonlit-policy',
component: MoonlitPolicyView,
meta: { title: 'Moonlit Preview Notice' }
},
{
path: '/login',
name: 'login',
component: LoginView,
meta: { title: '登录 - 菠萝蜜·沉浸式AI小说', guestOnly: true }
},
{
path: '/register',
name: 'register',
component: RegisterView,
meta: { title: '注册 - 菠萝蜜·沉浸式AI小说', guestOnly: true }
},
{
path: '/books',
name: 'books',
component: BooksView,
meta: { title: '书库 - 菠萝蜜·沉浸式AI小说' }
},
  {
    path: '/books/:id',
    name: 'book-detail',
    component: BookDetailView,
    meta: { title: '书籍详情 - 菠萝蜜·沉浸式AI小说' }
  },
{
path: '/reading/:bookId/:chapterId',
name: 'reading',
component: ReadingView,
meta: { title: '阅读 - 菠萝蜜·沉浸式AI小说', requiresAuth: true }
},
{
path: '/bookshelf',
name: 'bookshelf',
component: BookshelfView,
meta: { title: '我的书架 - 菠萝蜜·沉浸式AI小说', requiresAuth: true }
},
{
path: '/create',
name: 'create',
component: CreateView,
meta: { title: '自由创作 - 菠萝蜜', requiresAuth: true }
},
{
path: '/profile',
name: 'profile',
component: ProfileView,
meta: { title: '个人中心 - 菠萝蜜', requiresAuth: true }
},
{
path: '/admin',
name: 'admin',
component: AdminDashboard,
meta: { title: '管理后台 - 菠萝蜜' }
},
{
path: '/:pathMatch(.*)*',
name: 'not-found',
component: NotFoundView,
meta: { title: '页面未找到 - 菠萝蜜' }
}
]

const router = createRouter({
history: createWebHistory(import.meta.env.BASE_URL),
routes,
scrollBehavior(to, from, savedPosition) {
if (savedPosition) {
return savedPosition
} else {
return { top: 0 }
}
}
})

// 路由守卫 - 认证检查
router.beforeEach((to, from, next) => {
// 设置页面标题
const title = to.meta.title as string || '菠萝蜜'
document.title = title

// 检查是否需要认证
const requiresAuth = to.matched.some(record => record.meta.requiresAuth)
const guestOnly = to.matched.some(record => record.meta.guestOnly)

// 这里应该从store或localStorage获取用户登录状态
const isAuthenticated = localStorage.getItem('token') !== null

if (requiresAuth && !isAuthenticated) {
// 需要登录但未登录，重定向到登录页
if (to.path.startsWith('/moonlit')) {
next({ name: 'moonlit-login', query: { redirect: to.fullPath } })
} else {
next({ name: 'login', query: { redirect: to.fullPath } })
}
} else if (guestOnly && isAuthenticated) {
// 已登录用户访问guestOnly页面，重定向到首页
const guestRedirect = to.meta.guestRedirect as string | undefined
const redirect = typeof to.query.redirect === 'string' ? to.query.redirect : guestRedirect
if (redirect) {
next(redirect)
} else {
next({ name: 'home' })
}
} else {
// 正常导航
next()
}
})

export default router
